<template>
  <div>
    <div class="container solicitudes">
      <AvisoNotificaciones />
      <header
        class="h2-responsive"
      >
        Solicitudes
      </header>
      <ul class="lista-solicitudes">
        <router-link
          v-for="modul in modules"
          :key="modul.name"
          :to="`/solicitudes/${modul.name}`"
          tag="li"
        >
          Módulo {{ modul.name }}
          <mdb-badge
            color="danger"
            class="ml-2"
          >
            10
          </mdb-badge>
        </router-link>
      </ul>
    </div>
    <AlertaMsj :alerta-msj="alertaMsj" />
  </div>
</template>
<script>
import AlertaMsj from '../components/AlertaMsj.vue';
import AvisoNotificaciones from '../components/AvisoNotificaciones.vue';
import {mdbBadge} from 'mdbvue';
import gql from 'graphql-tag';
import moduleGql from '../graphql/module.gql';

export default {
  name: 'Solicitudes',
  components: {
    mdbBadge,
    AlertaMsj,
    AvisoNotificaciones,
  },
  data() {
    return {
      alertaMsj: {
        content: '',
      },
      permiso: 'default',
    };
  },
  apollo: {
    modules() {
      return {
        query: gql`${moduleGql}`,
        update: (data) => data.Module,
      };
    },
  },
};
</script>
<style lang="scss">
  .solicitudes {
    & > header {
      font-weight: 700;
      margin-bottom: 1rem;
      margin-top: 1rem;
      text-align: center;
    }
  }

  .lista-solicitudes {
    list-style-type: none;
    text-align: center;

    li {
      align-items: center;
      cursor: pointer;
      display: inline-flex;
      margin: .125rem .5rem;
      padding: .125rem .5rem;
    }
  }
</style>
